import { type FC } from "react";
import { type ExperienceAndCredentialCassetteProps } from "@legacy_user_frontend/components/pages/mypage/profiles/profiles_show/src/profile_show_props";
import { PrivateLabel } from "@legacy_user_frontend/components/pages/mypage/profiles/ui_parts/private_label";
import * as styles from "../styles.css";

export const ExperienceAndCredentialCassette: FC<ExperienceAndCredentialCassetteProps> = ({
  experienceAndCredential: { experiences, credentialItems, experiencesNote },
}) => {
  const credentialNames: string[] = [];
  return (
    <div className={styles.tableList}>
      {experiences.length > 0 && (
        <>
          <dt>経験</dt>
          <dd>
            <ul className={styles.list}>
              {experiences.map(({ jobTypeName, name }) => (
                <li key={`${jobTypeName}_${name}`}>
                  {jobTypeName} / {name}
                </li>
              ))}
            </ul>
          </dd>
        </>
      )}
      {experiencesNote && (
        <>
          <dt>
            <div>備考</div>
            <PrivateLabel />
          </dt>
          <dd>{experiencesNote}</dd>
        </>
      )}
      {credentialItems.length > 0 && (
        <>
          <dt>資格</dt>
          <dd>
            <ul className={styles.tagLabelList}>
              {credentialItems.map(({ credentialName, isWill }) => {
                if (credentialNames.find((item) => item === credentialName) === undefined) {
                  credentialNames.push(credentialName);
                  return (
                    <li key={credentialName}>
                      <span className={styles.tagLabel}>
                        {credentialName}
                        {isWill && <>(取得予定)</>}
                      </span>
                    </li>
                  );
                }
                return undefined;
              })}
            </ul>
          </dd>
        </>
      )}
    </div>
  );
};
